<app-header></app-header>

<div class="vincent_title_block vincent_corners">
    <div class="vincent_inner_text">
        <h1>{{"contact_us" | translate}}</h1>
    </div>
</div>
<div class="vincent_container vincent_сontact_us">
    <div class="row gutters flex-right" id="gutters">
        <div class="col-lg-6 col-md-6 col-sm-12 vincent_content">

            <div class="row vincent_сontact_block direction_rtl mg_top" id="vincent_сontact_block_1">
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_сontact_block_img"><img src="assets/imgs/basten.jpeg"  class="location-img"></div>
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_сontact_block_content">
                    <h5 class="right" id="content_1_1">{{"location" | translate}}</h5>
                    <p class="right" id="content_1_2">{{"basaten" | translate}}</p>
                    <p class="right" id="content_1_3">0503667401</p>
                    <p class="vincent_сontact_mail right" id="content_1_4">brooklyn@vincent.com</p>
                    <h5 class="right" id="content_1_5">{{"workin_hours" | translate}}</h5>
                    <p class="right" id="content_1_6">{{"friday" | translate}} – {{"monday" | translate}} from 8:00 am to 11:30 pm</p>
                    <a class="vincent_button float-right" href="https://www.google.com/maps?q=21.675655364990234,39.12046813964844&z=17&hl=en" id="vincent_button_1"><i class="fa fa-angle-left" aria-hidden="true" style="position: relative; right: 9px;"></i> {{"view_on_map" | translate}} </a>
                </div>
            </div>

            <div class="row vincent_сontact_block direction_rtl mg_top" id="vincent_сontact_block_2">
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_сontact_block_img"><img src="assets/imgs/alia.jpeg"  class="location-img"></div>
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_сontact_block_content">
                    <h5 class="right" id="content_2_1">{{"location" | translate}}</h5>
                    <p class="right" id="content_2_2">{{"al3alia" | translate}}</p>
                    <p class="right" id="content_2_3">0501273232</p>
                    <p class="vincent_сontact_mail right" id="content_2_4">brooklyn@vincent.com</p>
                    <h5 class="right" id="content_2_5">{{"workin_hours" | translate}}</h5>
                    <p class="right" id="content_2_6">{{"friday" | translate}} – {{"monday" | translate}} from 8:00 am to 11:30 pm</p>
                    <a class="vincent_button float-right" href="https://www.google.com/maps?q=21.746706008911133,39.14662551879883&z=17&hl=en" id="vincent_button_2"><i class="fa fa-angle-left" aria-hidden="true" style="position: relative; right: 9px;"></i> {{"view_on_map" | translate}} </a>
                </div>
            </div>
            
            <div class="row vincent_сontact_block direction_rtl mg_top" id="vincent_сontact_block_3">
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_сontact_block_img"><img src="assets/imgs/yaqot.jpeg"  class="location-img"></div>
                <div class="col-lg-6 col-md-6 col-sm-12 vincent_сontact_block_content">
                    <h5 class="right" id="content_3_1">{{"location" | translate}}</h5>
                    <p class="right" id="content_3_2">{{"alyaqot" | translate}}</p>
                    <p class="right" id="content_3_3">0533261133</p>
                    <p class="vincent_сontact_mail right" id="content_3_4">brooklyn@vincent.com</p>
                    <h5 class="right" id="content_3_5">{{"workin_hours" | translate}}</h5>
                    <p class="right" id="content_3_6">{{"friday" | translate}} – {{"monday" | translate}} from 8:00 am to 11:30 pm</p>
                    <a class="vincent_button float-right" href="https://www.google.com/maps?q=21.78770637512207,39.094154357910156&z=17&hl=en" id="vincent_button_3"><i class="fa fa-angle-left" aria-hidden="true" style="position: relative; right: 9px;"></i> {{"view_on_map" | translate}} </a>
                </div>
            </div>
        </div>
    </div>

            <div class="row justify_content">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h2 class="vincent_form_title center">{{"contact_us" | translate}}</h2>
                    <div class="vincent_form_block ">
                        <form  class="vincent_form" #f="ngForm" (ngSubmit)="addcontact(f)">
                            
                            <input type="text" ngModel name="name" #name="ngModel" class="form_user-name center" placeholder='{{"name" | translate}}' required>
                                <p *ngIf="name.invalid && name.touched" class="center">{{"please_enter_the_name" | translate}}</p>

                            <input type="text" ngModel name="email" #email="ngModel" id="email_inputxx" class="form_email center" placeholder='{{"email" | translate}}' required email>
                                <p *ngIf="email.errors?.required && email.touched" class="center">{{"please_enter_the_email" | translate}}</p>
                                <p *ngIf="email.errors?.email && email.touched" class="center"> {{"please_enter_valid_email" | translate}}</p>
                            
                            <textarea class="form_comment center" ngModel name="message" #message="ngModel" placeholder='{{"your_message" | translate}}' required></textarea>
                                <p *ngIf="message.invalid && message.touched" class="center">{{"please_enter_the_message" | translate}} </p>

                            <input class="center" type="submit" value='{{"send_message" | translate}}' [disabled]="f.invalid || submit == false">
                        </form>
                        <div class="alert alert-primary cus" role="alert" *ngIf="done == true">
                            {{"done_sending" | translate}}
                         </div>
                    </div>
                </div>
            </div>
</div>

<app-footer></app-footer>